import React from 'react';
import { CloseIcon } from '../Common/Icons';
import './Wellness.less';
import { Modal, Tabs } from 'antd';
import WellnessHistoryTableData from './WellnessHistoryTableData';
import WellnessHistoryInsightChart from './WellnessHistoryInsightChart';
import WellnessIconByTitle from './WellnessIconByTitle';
import PropTypes from 'prop-types';
import { unitTitleData } from './WellnessUtils';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const WellnessHistoryModal = ({
  showHistoryModal,
  closeHistoryModal,
  modalLoading,
  modalData,
  modalTitle,
  userMeasurement,
  deviceObj,
  timezone,
  selectedRange,
  setSelectedRange,
  is24hoursformat,
  userDefinedMeasurement,
  insightStartDateTime,
  insightEndDateTime,
  insightData,
  insightLoading,
  getTranslatedLabel,
}) => {
  const trans = useSelector(translator);
  return (
    <Modal
      open={showHistoryModal}
      onOk={closeHistoryModal}
      onCancel={closeHistoryModal}
      footer={null}
      closable={false}
      height={722}
      width={1472}
      className="wellness-modal-container"
    >
      <div className="modal-container">
        {/* Header Section */}
        <div className="wellness-modal-header-container">
          <div className="wellness-header-icon-title-new-container">
            <div className="wellness-header-icon-new">
              <WellnessIconByTitle title={modalTitle} style={{ width: '55px', height: '55px' }} />
            </div>
            <div className="wellness-modal-header-info">
              <div className="wellness-header-title-new">
                {trans(
                  String(unitTitleData['device_title'][modalTitle])
                    .split(' ')
                    .join('')
                    .toUpperCase()
                )}{' '}
                {trans('HISTORY')}
              </div>
              <div className="wellness-header-sub-title">{trans('HEALTH_READING_L')}</div>
            </div>
          </div>
          <div className="close-button" onClick={closeHistoryModal}>
            <CloseIcon className="close-icon" />
          </div>
        </div>

        {/* Tabs Section */}
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            className="wellness-tabs"
            tabPosition="top"
            items={[
              {
                label: trans('TABLEDATA'),
                key: '1',
                children: (
                  <WellnessHistoryTableData
                    modalLoading={modalLoading}
                    modalData={modalData}
                    userMeasurement={userMeasurement}
                    deviceObj={deviceObj}
                    getTranslatedLabel={getTranslatedLabel}
                  />
                ),
              },
              {
                label: trans('INSIGHTSANDCHART'),
                key: '2',
                children: (
                  <WellnessHistoryInsightChart
                    modalLoading={modalLoading}
                    modalData={modalData}
                    userMeasurement={userMeasurement}
                    modalTitle={modalTitle}
                    timezone={timezone}
                    selectedRange={selectedRange}
                    setSelectedRange={setSelectedRange}
                    is24hoursformat={is24hoursformat}
                    userDefinedMeasurement={userDefinedMeasurement}
                    insightStartDateTime={insightStartDateTime}
                    insightEndDateTime={insightEndDateTime}
                    insightData={insightData}
                    insightLoading={insightLoading}
                    getTranslatedLabel={getTranslatedLabel}
                  />
                ),
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
};

WellnessHistoryModal.prototype = {
  showHistoryModal: PropTypes.bool,
  closeHistoryModal: PropTypes.func,
  modalLoading: PropTypes.bool,
  modalData: PropTypes.array,
  modalTitle: PropTypes.string,
  userMeasurement: PropTypes.string,
  deviceObj: PropTypes.object,
  timezone: PropTypes.string,
  is24hoursformat: PropTypes.bool,
  selectedRange: PropTypes.string,
};

export default WellnessHistoryModal;
